/**
 * GET /api/v1/people/{id}/activity (v0.1.64): what one member of the team did. Sercan,
 * 2026-09-29: "Twin'de herkesin bugüne kadar neler yaptığını görebilmem lazım; bir kişiye
 * tıklayınca yaptıklarını görelim: verdiği onaylar, hazırladığı mailler, yaptığı aramalar".
 * The id is an agent (config id or panel id) or a human. Counters over the window, the tools
 * an agent called, and a timeline of runs, proposals, decisions, questions, sends, own replies
 * and lead scans, newest first. Panel only. Instants are epoch milliseconds, money micro USD.
 */
import { z } from 'zod';
const instant = z.number().int().nonnegative();
const count = z.number().int().nonnegative();
export const PERSON_KINDS = ['agent', 'human'];
export const PERSON_EVENT_KINDS = [
    'run',
    'proposal',
    'decision',
    'question',
    'answer',
    'send',
    'own_reply',
    'search',
];
export const personEventSchema = z.object({
    id: z.string(),
    at: instant,
    kind: z.enum(PERSON_EVENT_KINDS),
    /** Turkish, one line: "Çalıştı: E-posta: Jeep XJ", "Onayladı: Müşteri cevabı taslağı". */
    title: z.string(),
    detail: z.string().nullable(),
    /** The row's own status word, Turkish (tamamlandı, düştü, bekliyor, onaylandı, ...). */
    status: z.string().nullable(),
    costMicroUsd: count.nullable(),
    approvalId: z.string().nullable(),
    taskId: z.string().nullable(),
    /** A panel path to open (/onay/12, /ekip/99, /istek/9), when there is one. */
    link: z.string().nullable(),
});
export const personCountersSchema = z.object({
    runs: count,
    runsFailed: count,
    costMicroUsd: count,
    proposals: count,
    proposalsApproved: count,
    proposalsRejected: count,
    proposalsPending: count,
    decisions: count,
    approved: count,
    edited: count,
    rejected: count,
    questionsRaised: count,
    questionsAnswered: count,
    sends: count,
    ownReplies: count,
    searches: count,
    searchQueries: count,
    toolCalls: count,
});
export const personToolSchema = z.object({
    tool: z.string(),
    calls: count,
    denied: count,
});
/**
 * v0.1.222 (Sercan, 22 Oct 2026, Ekip › Ofis: "tıklayınca yaptıkları yapacaklarını göreyim"): an agent's open tasks,
 * the work it will do next, most urgent first. Empty for a person.
 */
export const personUpcomingSchema = z.object({
    id: z.string(),
    title: z.string(),
    /** Turkish status word: sırada, atandı, çalışıyor, onay bekliyor, düzeltilecek, ... */
    status: z.string(),
    priority: z.number().int().min(1).max(5),
    dueAt: instant.nullable(),
    /** A panel path, when the task has a page. */
    link: z.string().nullable(),
});
export const personActivitySchema = z.object({
    asOf: instant,
    person: z.object({
        /** The id the page was asked for, as the panel links it (agent panel id or human id). */
        id: z.string(),
        kind: z.enum(PERSON_KINDS),
        name: z.string(),
        /** Department or role, Turkish. */
        role: z.string(),
    }),
    /** The window the counters and the timeline cover, in days back from asOf. */
    days: z.number().int().positive(),
    counters: personCountersSchema,
    tools: z.array(personToolSchema),
    timeline: z.array(personEventSchema),
    upcoming: z.array(personUpcomingSchema),
});
/** Query of GET /people/{id}/activity: the window in days, 1..365, default 30. */
export const personActivityQuerySchema = z.strictObject({
    days: z.coerce.number().int().min(1).max(365).default(30),
});
//# sourceMappingURL=people.js.map